import useGlobalData from '@hooks/useGlobalData';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import { RichTextElementWrapper } from '@components/Page/Page.styles';
import tw, { css, styled } from 'twin.macro';

const FooterWrapper = styled.div`
  ${tw`border-t-grey border-t-[1px]`}
  ${tw`flex`}
  ${tw`mt-14`}
  ${tw`ml-[30px]`}
  ${tw`pt-[12px]`}
  ${css`
    p {
      ${tw`text-xs`}
      ${tw`min-w-[500px]`}
    }
    img {
      max-width: initial;
    }
  `}
`;

const IconWrapper = styled.div`
  ${tw`mt-[10px]`}
  ${tw`pl-5`}
`;

const Footer: React.FC = () => {
  const { footerContent } = useGlobalData();
  if (!footerContent.value) {
    return null;
  }
  return (
    <FooterWrapper>
      <RichTextElementWrapper>
        <RichTextElement value={footerContent.value} />
      </RichTextElementWrapper>
      <IconWrapper>
        <a
          href="https://creativecommons.org/licenses/by-nc/3.0/us/"
          rel="noreferrer"
          target="_blank"
          title="Creative Commons License"
        >
          <img
            alt="Creative Commons License"
            height={31}
            src="https://licensebuttons.net/l/by-nc/3.0/us/88x31.png"
            width={88}
          />
        </a>
      </IconWrapper>
    </FooterWrapper>
  );
};

export default Footer;
